import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveStockInDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-in/dealer-bulk-stock-in';
    return this.http.post(url, payload);
  }

  getBranchList(params: any){
    let url = environment.BASE_URL + '/v1/company/branches';
    return this.http.get(url, {params: params});
  }

  getSheetList(params: any) {
    let url = environment.BASE_URL + '/v1/sheet-processing';
    return this.http.get(url, {params: params});
  }

  getListDetails(fileId:any) {
    let url = environment.BASE_URL + `/v1/sheet-processing/${fileId}`;
    return this.http.get(url);
  }

  uploadSheet(file?: any, importType: string = 'WipeOut'){
    let formData = new FormData();
    formData.append('file', file);
    formData.append('importType', importType);
    let url = environment.BASE_URL + '/v1/sheet-processing/upload-stock-in';
    return this.http.post(url, formData);
  }

  getTyreDetails(selectedSize?:any){
    let url = environment.BASE_URL + '/v1/tyres/company';
    return this.http.get(url,{params:selectedSize});
  }

  getPhoneDetails(params:any){
    let url = environment.BASE_URL + '/v1/stock-out/get-customers';
    return this.http.get(url, { params: params });
  }

  getAllStockIn(pagination?:any,filterPendingInvoice?:any){
    let url = environment.BASE_URL + '/v1/stock-in';
    return this.http.get(url,{ params: pagination, ...filterPendingInvoice});
  }

  getStockInByStockInById(stcokInId:string){
    let url = environment.BASE_URL + `/v1/stock-in/${stcokInId}`;
    return this.http.get(url);
  }
  updateStockIn(stockInId:string,payload:any){
    let url = environment.BASE_URL + `/v1/stock-in/${stockInId}`;
    return this.http.put(url,payload);
  }

  saveStockInEdit(stockInId: string, payload: any) {
    let url = environment.BASE_URL + `/v1/stock-in/edit/${stockInId}`;
    return this.http.put(url, payload);
  }

  getAllStockOutList(filterPayMode?:any){
    let url = environment.BASE_URL + '/v1/stock-out';
    return this.http.get(url,{params:filterPayMode});
  }

  getAllServicetList(filterPayMode?:any){
    let url = environment.BASE_URL + '/v1/service-info';
    return this.http.get(url,{params:filterPayMode});
  }

  saveStockOutDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-out/customer-bulk-stock-out';
    return this.http.post(url,payload);
  }

  saveDealerStockOutDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-out/dealer-bulk-stock-out';
    return this.http.post(url,payload);
  }

  saveServiceDetails(payload:any){
    let url = environment.BASE_URL + '/v1/service-info';
    return this.http.post(url,payload);
  }

  uploadFile(payload: any): Observable<any> {
    return this.http.post(
      environment.BASE_URL + `/v1/file-upload`,
      payload
    );
  }

  saveTransferFromBranchDetails(payload:any){
    let url = environment.BASE_URL + '/v1/stock-in/bulk-transfer-from-branch';
    return this.http.post(url,payload);
  }

  freightDetails(payload:any) {
    const url = environment.BASE_URL + '/v1/stock-in/aggregate-prices';
    return this.http.post(url,payload);
  }

  getInventoryList(filters : any) {
    let url = environment.BASE_URL + '/v1/inventory';
    return this.http.get(url, {params: filters});
  }
  
  getInventoryDetails(fileId:any) {
    let url = environment.BASE_URL + `/v1/inventory/${fileId}`;
    return this.http.get(url);
  }

  downloadStock(fileID:any){
    let url = environment.BASE_URL + `/v1/inventory/${fileID}/export`;
    return this.http.get(url,
      { responseType: 'blob', observe: 'response' });
  } 

  downloadFiles(payload:any){
    let url = environment.BASE_URL + '/v1/inventory/export';
    return this.http.post(url,payload,
      { responseType: 'blob', observe: 'response' });
  } 
  
  exportstockOutList(payload: any) {
    let url = environment.BASE_URL + '/v1/sheet-processing/export';
    return this.http.post(url, {}, {params:payload});
  }

  getSalesExportList(params: any) {
    let url = environment.BASE_URL + `/v1/sheet-processing/stock-out/export`;
    return this.http.get(url, { params: params });
  }


  downloadSaleExportFile(url: string) {
    return this.http.get(url, { responseType: 'blob', observe: 'events', reportProgress: true });
  }

  getTransactionDetails(id: string) {
    let url = environment.BASE_URL + `/v1/stock-out/${id}`;
    return this.http.get(url, {});
  }

  saveStockOutEdit(id: string, payload: any) {
    let url = environment.BASE_URL + `/v1/stock-out/${id}`;
    return this.http.put(url, payload);
  }

  saveBranchStockTransferEdit(id: string, payload: any) {
    let url = environment.BASE_URL + `/v1/stock-out/edit-bulk-transfer-to-branch/${id}`;
    return this.http.put(url, payload);
  }

  getStockDataByInvoice(params: any) {
    let url = environment.BASE_URL + `/v1/stock-out/by-invoice-customer`;
    return this.http.get(url, { params: params });
  }

  getInventoryCount() {
    let url = environment.BASE_URL + `/v2/inventory/entries/counts`;
    return this.http.get(url);
  }

  getNewInventoryList(params: any) {
    let url = environment.BASE_URL + `/v2/inventory/entries`;
    return this.http.get(url, { params: params });
  }

}
